import React from "react";

// Safe fallbacks to prevent "ReferenceError" if your custom animation framework is globally defined or missing
const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {
    // Fallback if useReveal is completely undeclared
  }
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {
    // Fallback if hide is completely undeclared
  }
  return {};
};

const BOARD = [
  {
    name: "Martina Meneghello",
    role: "President",
    img: "https://i.postimg.cc/P5YvHkZv/bb1cc633-6dfc-47b9-a174-58c2442691ce.jpg",
  },
  {
    name: "Moshiur Ahmmed Lion",
    role: "Vice President",
    img: "https://i.postimg.cc/cLHJXgM3/fc4d1350-7816-4620-8339-3d8dba371cf1.jpg",
  },
  {
    name: "Giulio Lombardo",
    role: "Vice President",
    img: "https://i.postimg.cc/d0TvxMN4/83fd339b-6ec9-4965-b8eb-c5071d1a134d.jpg",
  },
  {
    name: "Filippo Cristante",
    role: "Vice President",
    img: "https://i.postimg.cc/bvw10wd6/b0d5231b-2abd-45f4-a456-5db093a6c4e9.jpg",
  },

  {
    name: "M. Borhan Uddin Ahmed",
    role: "Treasurer",
    img: "https://i.postimg.cc/0N71fP3L/475d8ee9-8a7c-4905-84d3-619bdcfa8cf7.jpg",
  },
  {
    name: "Antonio Occhiello",
    role: "Board Member",
    img: "https://i.postimg.cc/0jkC40ND/28cf2f99-406a-483b-a01b-bec22e251a60.jpg",
  },
  {
    name: "Ludovico Massari",
    role: "Board Member",
    img: "https://i.postimg.cc/T13r02kD/bbf879f0-e105-40b2-854b-249741177103.jpg",
  },
  {
    name: "Engr. Md. Nasir Ullah",
    role: "Board Member",
    img: "https://i.postimg.cc/GmJZ8qy0/c305293d-ed17-4961-a57f-3344f28d1535.jpg",
  },
  {
    name: "Silvia Marcon",
    role: "Board Member",
    img: "https://i.postimg.cc/BZTywmmf/4222387e-40c7-4a21-80b6-7fdea808b534.jpg",
  },
  {
    name: "Abdul Hakim",
    role: "Board Member",
    img: "https://i.postimg.cc/BvnNKx81/c99bf5ec-21b0-4662-8dc4-48071374e68b.jpg",
  },
  {
    name: "Andrea Venier",
    role: "Board Member",
    img: "https://i.postimg.cc/c4MSwspw/370bae04-6e4c-4e3f-9be4-2d091199b0c7.jpg",
  },
  {
    name: "Stefano Murdaca",
    role: "Board Member",
    img: "https://i.postimg.cc/ZnxrFBP2/97785f98-e8a8-4dd4-afb0-6a23c1afc86d.jpg",
  },
  {
    name: "Rayana Hossain",
    role: "Board Member",
    img: "https://i.postimg.cc/RhhHfsFd/d01a245b-1703-4b26-8348-66b1846f6d37.jpg",
  },
  {
    name: "Giuseppe Fracella",
    role: "Board Member",
    img: "https://i.postimg.cc/QtX4W17Y/1366262f-8e09-497e-81d7-ff651a8776e1.jpg",
  },

  {
    name: "Abu Henry",
    role: "Board Member",
    img: "https://i.postimg.cc/RFF5zKqx/2d4dd669-c6f5-469b-b955-1905d9aa67fd.jpg",
  },
  {
    name: "Antonio De Micco Padula",
    role: "Board Member",
    img: "https://i.postimg.cc/66MSnjYp/71646c73-bb19-42c2-82c5-d146ac561ebd.jpg",
  },
  // {
  //   name: "Silvia Rovelli",
  //   role: "Executive Director",
  //   img: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Unknown_person.jpg/250px-Unknown_person.jpg",
  // },
];

export const BoardGallery = () => {
  const ref = safeUseReveal();

  return (
    <section
      id="board-members"
      className="bg-white py-20 md:py-28 border-t border-gray-100 font-sans"
    >
      <div
        ref={ref}
        className="w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 xl:px-24"
      >
        {/* Centered Heading Title Block */}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2
            data-r
            className="text-4xl md:text-5xl font-extrabold text-[#0F1C35] tracking-tight"
            style={safeHide("up")}
          >
            Board of Directors
          </h2>
        </div>

        {/* Responsive Grid Layout for Board Members */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {BOARD.map((p, i) => (
            <div
              key={i}
              data-r
              style={safeHide("up")}
              className="group flex flex-col items-center text-center"
            >
              {/* Profile Image Container */}
              <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden mb-6 relative border border-gray-100 bg-gray-50 shadow-sm transition-all duration-300 group-hover:shadow-md group-hover:-translate-y-1">
                <img
                  src={p.img}
                  className="w-full h-full object-cover transition-all duration-700  group-hover:grayscale-0 group-hover:scale-[1.03]"
                  alt={p.name}
                  loading="lazy"
                />
              </div>

              {/* Name & Designation */}
              <h4 className="text-lg md:text-xl font-bold text-[#0F1C35] transition-colors duration-200 group-hover:text-[#0077b6]">
                {p.name}
              </h4>
              <p className="text-[#0F1C35] text-xs font-semibold uppercase tracking-wider mt-1.5">
                {p.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BoardGallery;
